var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-list",class:[
		`am-list--${_vm.size}`,
		`am-list--${_vm.theme}`,
		{
			'is-inline': _vm.inline,
			'is-dark': _vm.dark
		}
	]},_vm._l((_vm.items),function(item,key){return _c('am-text',{staticClass:"am-list__item",class:{'is-active': _vm.value == key	},attrs:{"type":"nav"},nativeOn:{"click":function($event){return _vm.$emit('input', key)}}},[_c('span',[_vm._v(" "+_vm._s(item)+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }